'use client';

export { CollectionRequestWorkflowWithDialog as CollectionRequestWorkflow } from './collection-request-workflow-dialog';
export type { CollectionWorkflowProps } from './types';

// For backward compatibility
export { CollectionRequestWorkflowWithDialog as default } from './collection-request-workflow-dialog';
